var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "#09091C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 2H2V63H63V2ZM0 0V65H65V0H0Z",
    fill: "#1BE1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 47H12V49H32V47Z",
    fill: "#1BE1F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1161 16H37.1102V25.1104C37.2264 25.1104 37.3425 25.1104 37.4586 25.1104C40.4783 21.7661 46.866 22.3427 50.0018 26.6096C53.2537 30.9919 52.4407 37.7959 48.2597 41.1402C45.3562 43.4466 40.1298 43.9079 37.3425 40.7942C37.3425 40.7942 37.2263 40.5636 36.9941 40.4483V40.6789C36.9941 41.7168 36.1811 42.5241 35.1358 42.5241H32V16H32.1161ZM46.7499 32.9523C46.7499 29.954 44.6593 27.7628 41.8719 27.7628C39.0846 27.7628 36.9941 29.954 36.9941 32.9523C36.9941 35.9507 39.0846 38.1418 41.8719 38.1418C44.5432 38.1418 46.7499 35.8354 46.7499 32.9523Z",
    fill: "#1BE1F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildLogo);
export default __webpack_public_path__ + "static/media/build_logo.54772bc390dc497869de76630c1ef59b.svg";
export { ForwardRef as ReactComponent };